import { createFileRoute } from '@tanstack/react-router'
import { SecurityScreen } from '@/features/account/security-screen'

export const Route = createFileRoute('/_authenticated/account/security')({
  component: SecurityScreen,
})
